import { Button } from '@repo/ui/components/ui/button'
import { Callout } from '@repo/ui/components/ui/callout'
import { createFileRoute } from '@tanstack/react-router'
import { DocumentRouteShell } from '@/components/app/route-shells'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'
import { trpc } from '@/lib/trpc'

export const Route = createFileRoute('/_app/admin/content')({
  component: AdminContentPage,
  staticData: {
    breadcrumbs: [{ label: 'Content' }],
  } satisfies RouteStaticData,
})

function AdminContentPage() {
  const announcements = trpc.admin.content.announcements.list.useQuery()
  const data = announcements.data as { message?: string } | undefined

  return (
    <DocumentRouteShell>
      {announcements.isError ? (
        <Callout>
          <p className="text-sm text-muted-foreground">
            Failed to load content integration. {(announcements.error as unknown as Error).message}
          </p>
          <Button asChild variant="outline" size="sm" className="mt-3">
            <a href="https://app.knock.app" target="_blank" rel="noopener noreferrer">
              Open Knock
            </a>
          </Button>
        </Callout>
      ) : (
        <Callout>
          <p className="text-sm text-muted-foreground">
            {announcements.isLoading
              ? 'Loading content integration...'
              : data?.message || 'Content data will appear here as your workspace activity grows.'}
          </p>
        </Callout>
      )}
    </DocumentRouteShell>
  )
}
